// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableS-table--Type2 {
  display: grid;
  gap: 0;
  width: max-content;
  background: white;
  border-bottom: 0.1vw #1a6a7c solid;
  border-right: 0.1vw #1a6a7c solid;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}
.tableS-cell-selected {
  background: rgb(147, 224, 237);
}
.tableS-cell--Type2 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.7vw;
  font-weight: bold;
  border-left: 0.1vw #1a6a7c solid;
  border-top: 0.1vw #1a6a7c solid;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/TablesSecret/styles/TablesSBoardType2.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,iCAAiC;EACjC;;mCAEiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;AACjC","sourcesContent":[".tableS-table--Type2 {\n  display: grid;\n  gap: 0;\n  width: max-content;\n  background: white;\n  border-bottom: 0.1vw #1a6a7c solid;\n  border-right: 0.1vw #1a6a7c solid;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n.tableS-cell-selected {\n  background: rgb(147, 224, 237);\n}\n.tableS-cell--Type2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.7vw;\n  font-weight: bold;\n  border-left: 0.1vw #1a6a7c solid;\n  border-top: 0.1vw #1a6a7c solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
